import { useState } from "react";
import { motion } from "framer-motion";
import { Menu, X, MessageCircle } from "lucide-react";
import { LogoFull } from "@/components/Logo";
import { WHATSAPP_URL } from "@/constants/site";

const LINKS = [
  { href: "#services", label: "Services" },
  { href: "#catalogue", label: "Catalogue" },
  { href: "#contact", label: "Contact" },
];

export const Navbar = ({ onQuote }) => {
  const [open, setOpen] = useState(false);

  return (
    <motion.header
      data-testid="navbar"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
      className="fixed top-0 inset-x-0 z-50 bg-[#0D1117]/80 backdrop-blur-md border-b border-[#21262D]"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-[72px] flex items-center justify-between">
        <a href="#top" data-testid="navbar-logo-link" aria-label="Retour en haut">
          <LogoFull />
        </a>

        <nav className="hidden md:flex items-center gap-8" data-testid="navbar-links">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="font-mono text-xs uppercase tracking-[0.2em] text-[#8B949E] hover:text-[#F2541B] transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-whatsapp-btn"
            className="w-10 h-10 rounded-full border border-[#21262D] flex items-center justify-center text-[#2D5A40] hover:text-[#F0F6FC] hover:border-[#2D5A40] hover:bg-[#1B3B2B]/40 transition-colors duration-300"
            aria-label="WhatsApp"
          >
            <MessageCircle size={17} />
          </a>
          <button
            onClick={() => onQuote()}
            data-testid="nav-devis-btn"
            className="bg-[#F2541B] hover:bg-[#D9420B] text-white font-display font-bold uppercase tracking-wide text-sm px-6 py-2.5 rounded-full transition-colors duration-300"
          >
            Devis gratuit
          </button>
        </div>

        <button
          className="md:hidden text-[#F0F6FC]"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          aria-label="Menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#21262D] bg-[#0D1117] px-5 py-6 flex flex-col gap-5" data-testid="nav-mobile-menu">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
              className="font-display font-bold uppercase text-xl text-[#F0F6FC]"
            >
              {l.label}
            </a>
          ))}
          <button
            onClick={() => { setOpen(false); onQuote(); }}
            data-testid="nav-mobile-devis-btn"
            className="bg-[#F2541B] text-white font-display font-bold uppercase px-6 py-3 rounded-full w-fit"
          >
            Devis gratuit
          </button>
        </div>
      )}
    </motion.header>
  );
};
